import { render, staticRenderFns } from "./BookingIntakeTab.vue?vue&type=template&id=51be9888&scoped=true"
import script from "./BookingIntakeTab.vue?vue&type=script&lang=js"
export * from "./BookingIntakeTab.vue?vue&type=script&lang=js"
import style0 from "./BookingIntakeTab.vue?vue&type=style&index=0&id=51be9888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51be9888",
  null
  
)

export default component.exports